// ChatContext.js
import React, { createContext, useState } from "react";

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [newChat, setNewChat] = useState([]);

  return (
    <ChatContext.Provider value={{ newChat, setNewChat }}>
      {children}
    </ChatContext.Provider>
  );
};
